import { defaultFill } from '../utils/constants';
var muiChevronDownGlyph = {
    paths: [
        {
            path: 'M5.83980762,7 C5.97792576,6.99557242 6.10633247,6.96679317 6.22502775,6.91366224 C6.34372302,6.86053131 6.45486496,6.77862113 6.55845357,6.66793169 L11.4076952,1.56736243 C11.5803428,1.39025933 11.6666667,1.17773561 11.6666667,0.929791271 C11.6666667,0.75711575 11.6267419,0.599936749 11.5468923,0.458254269 C11.4670428,0.31657179 11.359138,0.204775459 11.223178,0.122865275 C11.0872179,0.0409550917 10.9372302,0 10.7732149,0 C10.5228758,0 10.30275,0.0951929159 10.1128376,0.285578748 L5.55493896,5.10721063 L6.12467629,5.10721063 L1.55382908,0.285578748 C1.36391664,0.0951929159 1.14379085,0 0.89345172,0 C0.729436429,0 0.579448761,0.0409550917 0.443488716,0.122865275 C0.307528672,0.204775459 0.199623875,0.31657179 0.119774325,0.458254269 C0.0399247749,0.599936749 0,0.75711575 0,0.929791271 C0,1.05376344 0.0215809594,1.16888046 0.0647428783,1.27514231 C0.107904797,1.38140417 0.172647675,1.48102467 0.258971513,1.5740038 L5.1082131,6.66793169 C5.32833888,6.88931056 5.57220372,7 5.83980762,7 Z',
            fill: defaultFill,
        },
    ],
    title: 'Chevron Down',
    width: 12,
    height: 7,
};
var muiChevronDown = {
    base: muiChevronDownGlyph,
};
export { muiChevronDown };
//# sourceMappingURL=chevronDown.js.map